
import dayjs from 'dayjs';

import advancedFormat from 'dayjs/plugin/advancedFormat';
dayjs.extend(advancedFormat);

export { dayjs };
